module.exports = __webpack_public_path__ + "img/fosun.01924a66.png";